export default {
      id: "defn-usage",
      viewBox: "0 0 44 59",
      url: __webpack_public_path__ + "../../sprite.svg#defn-usage",
      toString: function () {
        return this.url;
      }
    }